import {useTranslationWithOverride} from "components/src/hook/UseTranslationWithOverride";
import {SideBar} from 'components/src/sidebar/SideBar'
import {
    useEnterprisePortalPropertiesContext
} from "enterprise-components/src/hook/UseEnterprisePortalPropertiesContext";
import {CreateNewMailPopup} from "enterprise-components/src/webmail/CreateNewMailPopup";
import {
    Home as DashboardIcon,
    Mail as MessagesIcon,
    MailIn,
    Plus as NewMailIcon,
    PrivacyPolicy as PdfIcon,
    Send
} from "iconoir-react";
import {useState} from "react";
import {Button} from "react-bootstrap";

interface SendNewMailButtonProps {
    onNewMail: () => void;
}

const SendNewMailButton = ({onNewMail}: SendNewMailButtonProps) =>
{
    const {t} = useTranslationWithOverride();
    const {properties} = useEnterprisePortalPropertiesContext();

    return(
        <div className="ms-1 pe-0 mt-1 mb-1">
            <Button variant="success"
                    className="w-100"
                    disabled={!properties?.webmailIsCreateNewMailAllowed}
                    onClick={onNewMail}>
                <NewMailIcon height="1em" width="1em"/> {t("portal.messages.new-mail")}
            </Button>
        </div>
    )
}

/**
 * AppSidebar component provides the main navigation sidebar of the application.
 */
export const EnterprisePortalSidebar = () =>
{
    const {t} = useTranslationWithOverride();
    const {properties} = useEnterprisePortalPropertiesContext();
    const [showNewMailPopup, setShowNewMailPopup] = useState<boolean>(false);

    return (
        <>
            {showNewMailPopup &&
                <CreateNewMailPopup onClose={() => setShowNewMailPopup(false)}/>
            }
            <SideBar>
                <SideBar.Item title={t('portal-dashboard-title')} link="/" icon={<DashboardIcon/>}/>

                {properties?.webmailEnabled &&
                    <SideBar.Dropdown title={t("portal.sidebar.messages-title")} icon={<MessagesIcon/>}>
                        <SideBar.Item title={t('portal.sidebar.inbox-title')} link="/messages/inbox" icon={<MailIn/>}/>
                        <SideBar.Item title={t('portal.sidebar.sent-title')} link="/messages/sent" icon={<Send/>}/>
                        <SideBar.Item component={<SendNewMailButton onNewMail={() => setShowNewMailPopup(true)}/>}/>
                    </SideBar.Dropdown>
                }

                {properties?.pdfEnabled &&
                    <SideBar.Item title={t('portal.sidebar.pdf-password-title')} link="/pdf/otp" icon={<PdfIcon/>}/>
                }
            </SideBar>
        </>
    )
}
